import { Alert, Anchor, Badge, Card, Group, Stack, Text } from '@mantine/core'
import type { SubscriptionWithRelations } from '@markku/types'
import { useDisclosure } from '@mantine/hooks'
import { IconUserCheck } from '@tabler/icons-react'
import { ContractTermsModal } from './ContractTermsModal'
import { SubscriptionPackageList } from './SubscriptionPackageList'

interface ActiveSubscriptionDetailsProps {
  subscriptionDetails: SubscriptionWithRelations
}

export function ActiveSubscriptionDetails({
  subscriptionDetails,
}: ActiveSubscriptionDetailsProps) {
  const [termsOpened, { open: openTerms, close: closeTerms }] =
    useDisclosure(false)

  const basePrice = subscriptionDetails.basePriceMonthly
  const effectivePrice = subscriptionDetails.effectivePriceMonthly
  const hasDiscount = effectivePrice && effectivePrice !== basePrice

  return (
    <>
      <Card withBorder p="md" bg="green.0">
        <Stack gap="md">
          <Group justify="space-between" align="center">
            <Text fw={600}>Aktiivinen tilaus</Text>
            <Badge color="green" variant="filled">
              Aktiivinen
            </Badge>
          </Group>
          <Group justify="space-between">
            <Text size="lg" fw={600}>
              {subscriptionDetails.displayName}
            </Text>
            <Group gap={6}>
              {hasDiscount && (
                <Text size="lg" fw={700} td="line-through" c="dimmed">
                  {basePrice} €
                </Text>
              )}
              <Text size="lg" fw={700}>
                {hasDiscount ? effectivePrice : basePrice} €/kk
              </Text>
            </Group>
          </Group>

          {subscriptionDetails.subscriptionPackageVersions?.length && (
            <SubscriptionPackageList
              subscriptionPackageVersions={
                subscriptionDetails.subscriptionPackageVersions
              }
            />
          )}

          {subscriptionDetails.additionalTerms && (
            <Alert
              icon={<IconUserCheck size={16} />}
              color="green"
              variant="light"
            >
              <Text
                size="sm"
                fw={500}
                style={{
                  wordBreak: 'break-word',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {subscriptionDetails.additionalTerms}
              </Text>
            </Alert>
          )}

          <Anchor onClick={openTerms} size="sm" ta="center">
            Näytä sopimusehdot
          </Anchor>
        </Stack>
      </Card>

      <ContractTermsModal
        opened={termsOpened}
        onClose={closeTerms}
        termsVersion={subscriptionDetails.termsVersion}
      />
    </>
  )
}
